import React, { useEffect, useState } from 'react';
import api from '../../utils/api';
import { Plus, Edit, Trash2, Search } from 'lucide-react';
import { toast } from 'sonner';

const Plants = () => {
  const [plants, setPlants] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showModal, setShowModal] = useState(false);
  const [editing, setEditing] = useState(null);
  const [searchTerm, setSearchTerm] = useState('');
  const [formData, setFormData] = useState({ name: '', location: '', capacity: '' });

  useEffect(() => { fetchPlants(); }, []);
  const fetchPlants = async () => { try { const r = await api.get('/sales/plants'); setPlants(r.data); } catch(e){} finally { setLoading(false); } };

  const openCreate = () => { setEditing(null); setFormData({ name: '', location: '', capacity: '' }); setShowModal(true); };
  const openEdit = (p) => { setEditing(p); setFormData({ name: p.name, location: p.location || '', capacity: p.capacity || '' }); setShowModal(true); };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      if (editing) await api.put(`/sales/plants/${editing.id}`, formData);
      else await api.post('/sales/plants', formData);
      setShowModal(false); fetchPlants();
    } catch (err) { toast.error(err.response?.data?.detail || 'Failed'); }
  };

  const deletePlant = async (id, name) => {
    if (!window.confirm(`Delete plant "${name}"?`)) return;
    try { await api.delete(`/sales/plants/${id}`); fetchPlants(); } catch(e) { toast.error(e.response?.data?.detail || 'Failed'); }
  };

  const filtered = plants.filter(p => p.name.toLowerCase().includes(searchTerm.toLowerCase()) || p.plant_code.toLowerCase().includes(searchTerm.toLowerCase()));

  return (
    <div data-testid="plants-page">
      <div className="flex items-center justify-between mb-4">
        <h1 style={{ fontSize: '24px', fontWeight: 700, margin: 0 }}>Plant Master</h1>
        <button onClick={openCreate} className="btn btn-primary" data-testid="add-plant-btn"><Plus size={16} /> Add Plant</button>
      </div>
      <div className="card mb-4">
        <div className="form-group" style={{ marginBottom: 0 }}>
          <div style={{ position: 'relative' }}>
            <Search size={16} style={{ position: 'absolute', left: '12px', top: '50%', transform: 'translateY(-50%)', color: 'var(--text-tertiary)' }} />
            <input type="text" className="form-input" placeholder="Search plants..." value={searchTerm} onChange={(e) => setSearchTerm(e.target.value)} style={{ paddingLeft: '40px' }} data-testid="search-input" />
          </div>
        </div>
      </div>
      <div className="card">
        {loading ? <div>Loading...</div> : (
          <div className="table-container">
            <table>
              <thead><tr><th>Code</th><th>Name</th><th>Location</th><th>Capacity</th><th>Status</th><th>Actions</th></tr></thead>
              <tbody>
                {filtered.map(p => (
                  <tr key={p.id} data-testid={`plant-row-${p.plant_code}`}>
                    <td className="font-mono">{p.plant_code}</td>
                    <td>{p.name}</td>
                    <td>{p.location || '-'}</td>
                    <td>{p.capacity || '-'}</td>
                    <td><span className={`badge ${p.status === 'active' ? 'badge-success' : 'badge-danger'}`}>{p.status}</span></td>
                    <td>
                      <div className="flex gap-2">
                        <button onClick={() => openEdit(p)} className="btn btn-ghost btn-sm" data-testid={`edit-btn-${p.plant_code}`}><Edit size={14} /></button>
                        <button onClick={() => deletePlant(p.id, p.name)} className="btn btn-ghost btn-sm" data-testid={`delete-btn-${p.plant_code}`}><Trash2 size={14} color="#DC2626" /></button>
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>
      {showModal && (
        <div className="modal-overlay" data-testid="plant-modal">
          <div className="modal-content" style={{ maxWidth: '450px' }} onClick={(e) => e.stopPropagation()}>
            <div className="modal-header"><h2 style={{ margin: 0, fontSize: '18px', fontWeight: 700 }}>{editing ? 'Edit Plant' : 'Add Plant'}</h2></div>
            <form onSubmit={handleSubmit}>
              <div className="modal-body">
                <div className="form-group"><label className="form-label">Name *</label><input type="text" className="form-input" value={formData.name} onChange={(e) => setFormData({...formData, name: e.target.value})} required data-testid="name-input" /></div>
                <div className="form-group"><label className="form-label">Location</label><input type="text" className="form-input" value={formData.location} onChange={(e) => setFormData({...formData, location: e.target.value})} data-testid="location-input" /></div>
                <div className="form-group"><label className="form-label">Capacity</label><input type="text" className="form-input" value={formData.capacity} onChange={(e) => setFormData({...formData, capacity: e.target.value})} data-testid="capacity-input" /></div>
              </div>
              <div className="modal-footer">
                <button type="button" onClick={() => setShowModal(false)} className="btn btn-secondary">Cancel</button>
                <button type="submit" className="btn btn-primary" data-testid="submit-plant-btn">{editing ? 'Update' : 'Add Plant'}</button>
              </div>
            </form>
          </div>
        </div>
      )}
    </div>
  );
};

export default Plants;
